import { AxiosInstance } from 'axios';
import { makeObservable, observable, runInAction } from 'mobx';
import GlobalStore from './GlobalStore';
import EngineeringReportModel from '../Models/EngineeringReportModel';
import EngineeringWorkflowModel from '../Models/EngineeringWorkflowModel';
import EngineeringWorkflowIdModel, { WorkflowFilters, WorkflowReflections } from '../Models/EngineeringWorkflowIdModel';
import workflowIds from '../assets/data/workflowIds.json';

export default class MastersEngineeringReportStore {
    constructor(globalStore: GlobalStore) {
        this.axios = globalStore.axios;

        makeObservable(this, {
            experiences: observable,
            initialised: observable,
            filtered: observable,
            workflow: observable,
            workflowIds: observable,
            studentWorkflowFilters: observable,
            studentWorkflowReflections: observable,
            hasLabel: observable
        });
    }

    axios: AxiosInstance;

    experiences?: EngineeringReportModel[];

    filtered?: EngineeringReportModel[];

    workflow?: EngineeringWorkflowModel[];

    workflowIds?: EngineeringWorkflowIdModel[];

    studentWorkflowFilters?: WorkflowFilters;

    studentWorkflowReflections?: WorkflowReflections[];

    hasLabel = false;

    initialised = false;

    loadReflectionsAsync = async () => {
        const experience = await this.axios.get<EngineeringReportModel[]>('/api/mastersengineering/ers');
        runInAction(() => {
            this.experiences = experience.data;
            this.filtered = experience.data;
        });
    };

    loadWorkflowDataAsync = async () => {
        const workflow = await this.axios.get<EngineeringWorkflowModel[]>('/api/mastersengineering/workflow/');
        runInAction(() => {
            this.workflow = workflow.data;
            this.workflowIds = workflowIds;
        });
    };

    getLabelAsync = async () => {
        try {
            await this.axios.get('/api/mastersengineering/label/');
            runInAction(() => {
                this.hasLabel = true;
            });
        } catch (err) {
            runInAction(() => {
                this.hasLabel = false;
            });
        }
    };

    initialiseAsync = async () => {
        if (this.initialised) {
            return;
        }
        runInAction(() => {
            this.initialised = true;
        });
        runInAction(() => {
            this.loadReflectionsAsync();
            this.loadWorkflowDataAsync();
            this.getLabelAsync();
        });
    };
}
